import { render, staticRenderFns } from "./CustomerListPage.vue?vue&type=template&id=d8e06780&"
import script from "./CustomerListPage.vue?vue&type=script&lang=js&"
export * from "./CustomerListPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerListPage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
